// Single source of truth for predictive-score tiers, shared by the grid cell badge and the
// detail-panel gauge so a given score always maps to the same label and color.
//
// Bands and colors are the product/design spec for the HOPI UI. Note these are HOPI-facing
// display tiers and intentionally differ from the scoring engine's `scoreInterpretation` bands;
// the UI computes the label from the numeric score and does not render the server's interpretation
// string, so there is no cross-surface conflict.
//
// `min` is the inclusive lower bound for the band. Ordered high → low so the first match wins.
export const SCORE_TIERS = [
	{ min: 95, label: "Exceptional",   colorClass: "score-green",  hex: "#4caf50" },
	{ min: 90, label: "Excellent",     colorClass: "score-green",  hex: "#4caf50" },
	{ min: 80, label: "Strong",        colorClass: "score-green",  hex: "#4caf50" },
	{ min: 70, label: "Above Average", colorClass: "score-orange", hex: "#ff9800" },
	{ min: 55, label: "Average",       colorClass: "score-orange", hex: "#ff9800" },
	{ min: 40, label: "Below Average", colorClass: "score-red",    hex: "#f44336" },
	{ min: 0,  label: "Poor",          colorClass: "score-red",    hex: "#f44336" },
];

// Returns the tier for a score, or null when there is no score to classify.
export function getScoreTier(score) {
	if (score === null || score === undefined) { return null; }
	return SCORE_TIERS.find(tier => score >= tier.min) || SCORE_TIERS[SCORE_TIERS.length - 1];
}

// Convenience accessors for the two surfaces.
export function getScoreColorClass(score) {
	return getScoreTier(score)?.colorClass || "";
}

export function getScoreColorHex(score) {
	return getScoreTier(score)?.hex || "#f44336";
}

export function getScoreLabel(score) {
	return getScoreTier(score)?.label || "";
}
